"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCurrentSession = checkCurrentSession;
exports.checkMid2Session = checkMid2Session;
exports.createSession = createSession;
exports.default = _default;
exports.getNotifications = getNotifications;
exports.infoUA = exports.infoMenu = exports.infoAuth = exports.infoAT = void 0;
exports.initAppframe = initAppframe;
exports.logout = logout;
exports.runInactivityTimer = runInactivityTimer;
exports.runLifetimeTimer = runLifetimeTimer;
exports.runLogoutTimer = runLogoutTimer;
exports.trackUser = trackUser;
var _effects = require("redux-saga/effects");
var _getTime = _interopRequireDefault(require("date-fns/getTime"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _debug = _interopRequireDefault(require("debug"));
var _SessionStorage = _interopRequireDefault(require("../../shared/SessionStorage"));
var _AuthStrategy = require("../services/AuthStrategy");
var _session = require("../selectors/session");
var _appconfig = require("../selectors/appconfig");
var _menu = require("../selectors/menu");
var actions = _interopRequireWildcard(require("../actions"));
var _snacks = require("../services/snacks");
var _auth = require("../utils/auth");
var _user = require("../utils/user");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const infoAT = exports.infoAT = (0, _debug.default)('AppFrame:activity-tracker');
const infoAuth = exports.infoAuth = (0, _debug.default)('AppFrame:auth');
const infoUA = exports.infoUA = (0, _debug.default)('AppFrame:usage-analytics');
const infoMenu = exports.infoMenu = (0, _debug.default)('AppFrame:menu');
function* createSession(action) {
  try {
    const sessionAPI = yield (0, _effects.getContext)('sessionApi');
    yield (0, _effects.call)(sessionAPI.create, action.payload.token);
    yield (0, _effects.put)(actions.initAppFrame({
      isClearLogin: true
    }));
  } catch (error) {
    yield (0, _effects.call)(_AuthStrategy.authStrategy.redirectToLogin);
  }
}
function* runLogoutTimer(action) {
  const {
    modalDuration
  } = action.payload;
  yield (0, _effects.call)(infoAT, 'logout timer', modalDuration * 1000);
  const {
    timeout
  } = yield (0, _effects.race)({
    timeout: (0, _effects.delay)(modalDuration * 1000),
    cancel: (0, _effects.take)(actions.GET_SESSION_SUCCESS)
  });
  if (timeout) {
    yield (0, _effects.call)(_AuthStrategy.authStrategy.redirectToLogin);
  }
}
function* runLifetimeTimer(action) {
  try {
    const {
      expirationTime,
      currentTime,
      modalDuration
    } = action.payload;
    const lifetimeDelay = (0, _getTime.default)((0, _parseISO.default)(expirationTime)) - (0, _getTime.default)(currentTime) - modalDuration * 1000;
    yield (0, _effects.call)(infoAT, 'lifetime timer', lifetimeDelay);
    yield (0, _effects.delay)(lifetimeDelay > 0 ? lifetimeDelay : 0);
    yield (0, _effects.put)(actions.toggleLifetimeModal(true));
    yield (0, _effects.put)(actions.setLogoutTimer(modalDuration));
  } catch (error) {
    yield (0, _effects.call)(global.console.log, 'error', error);
  }
}
function* runInactivityTimer(action) {
  try {
    const {
      expirationTime,
      currentTime,
      modalDuration
    } = action.payload;
    const idleDelay = (0, _getTime.default)((0, _parseISO.default)(expirationTime)) - (0, _getTime.default)(currentTime) - modalDuration * 1000;
    yield (0, _effects.call)(infoAT, 'idle timer', idleDelay);
    yield (0, _effects.delay)(idleDelay > 0 ? idleDelay : 0);
    yield (0, _effects.put)(actions.toggleIdleModal(true));
    yield (0, _effects.put)(actions.setLogoutTimer(modalDuration));
  } catch (error) {
    yield (0, _effects.call)(global.console.log, 'error', error);
  }
}
function* getPCASProfile() {
  try {
    const profileApi = yield (0, _effects.getContext)('profileApi');
    const {
      email
    } = yield (0, _effects.call)(profileApi.getProfile);
    return email;
  } catch (error) {
    yield (0, _effects.call)(infoAuth, 'error during getting profile', error);
  }
  return undefined;
}
function* trackUser(action) {
  var _config$auth;
  const {
    payload
  } = action;
  const {
    [actions.INIT_APPFRAME]: {
      mid2AccessToken,
      mid2Enabled
    } = {}
  } = payload ?? {};
  const config = yield (0, _effects.getContext)('config');
  const appconfig = yield (0, _effects.select)(_appconfig.getAppconfig);
  const session = yield (0, _effects.select)(_session.getSession);
  let identifier;
  let email;
  if (mid2Enabled) {
    const sessionAttrs = mid2AccessToken ? (0, _auth.parseJWT)(mid2AccessToken) : {};
    identifier = sessionAttrs.sub;
    email = sessionAttrs.email;
  }
  if ((config === null || config === void 0 ? void 0 : (_config$auth = config.auth) === null || _config$auth === void 0 ? void 0 : _config$auth.connector) === 'pcas') {
    identifier = session.identity.sub;
    email = yield (0, _effects.call)(getPCASProfile);
  }
  (0, _user.trackUserIdentity)(identifier, email, {
    heapAppId: config.heapAppId,
    isEmailTrackingEnabled: appconfig.isEmailTrackingEnabled
  });
}
function* checkCurrentSession(action) {
  try {
    const sessionAPI = yield (0, _effects.getContext)('sessionApi');
    const config = yield (0, _effects.getContext)('config');
    const auth = config.auth || {};
    const prolongationStopped = yield (0, _effects.select)(_session.isProlongationStopped);
    yield (0, _effects.call)(infoAuth, 'check current session', action.payload, prolongationStopped);
    if (prolongationStopped && action.payload) return;
    const session = yield (0, _effects.call)(sessionAPI.get);
    if (auth.connector === 'pcas' && auth.modalDuration) {
      const previousSession = yield (0, _effects.select)(_session.getSession);
      yield (0, _effects.call)(infoAT, 'prolong session', auth, session, previousSession);
      if (session.expiresOn === previousSession.expiresOn) {
        yield (0, _effects.put)(actions.setLifetimeTimer(session.expiresOn, new Date(), auth.modalDuration));
      } else {
        yield (0, _effects.put)(actions.setInactivityTimer(session.expiresOn, new Date(), auth.modalDuration));
      }
    }
    yield (0, _effects.put)(actions.getSessionSuccess(session));
  } catch (error) {
    yield (0, _effects.call)(infoAuth, 'error during check session', error);
    yield (0, _effects.call)(_AuthStrategy.authStrategy.redirectToLogin);
  }
}
function* getNotifications(isClearLogin, appconfig) {
  const config = yield (0, _effects.getContext)('config');
  if (appconfig.accountPrefix) {
    yield (0, _effects.put)(actions.getNotificationsPending());
  }
  if (config.wsPath) {
    yield (0, _effects.put)(actions.websocketOpenPending(window.location.host, window.location.protocol, config.wsPath));
  }
  if (config.uaPath) {
    yield (0, _effects.put)(actions.usageAnalyticsOpenPending(window.location.host, window.location.protocol, config.uaPath, isClearLogin));
  }
  if (!config.uaPath && !!config.apiPrefixes.uaGW && isClearLogin) {
    yield (0, _effects.put)(actions.usageAnalyticsSendMessage('AppFrame', 'Action', 'Login', window.location.pathname, 'ua'));
    infoUA('UA tracked a login action');
  }
}
function* checkMid2Session(accessToken) {
  const session = accessToken ? (0, _auth.parseJWT)(accessToken) : {};
  yield (0, _effects.put)(actions.getSessionSuccess({
    attrs: session
  }));
}
function* initAppframe(action) {
  try {
    const config = yield (0, _effects.getContext)('config');
    const {
      isClearLogin,
      mid2Enabled,
      mid2AccessToken
    } = action.payload || {};
    const lpbPrefix = config.apiPrefixes.lpb;
    yield (0, _effects.call)(infoAuth, 'init AppFrame', action.payload);
    if (!mid2Enabled) {
      yield (0, _effects.put)(actions.getSessionPending());
    }
    if (lpbPrefix) {
      yield (0, _effects.put)(actions.getAppconfigPending());
    } else {
      yield (0, _effects.put)(actions.getAppconfigSuccess({}));
    }
    if (mid2Enabled) {
      yield (0, _effects.call)(checkMid2Session, mid2AccessToken);
    }
    yield (0, _effects.take)(actions.GET_APP_CONFIG_SUCCESS);
    const appconfig = yield (0, _effects.select)(_appconfig.getAppconfig);
    const solutions = yield (0, _effects.select)(_menu.getSolutions);
    infoMenu('Init AppFrame solutions:', solutions);
    if (lpbPrefix && (appconfig.menu || appconfig.header) && (!solutions.length || isClearLogin || !appconfig.sitemapCache)) {
      yield (0, _effects.put)(actions.getMenuDataPending());
    }
    yield (0, _effects.call)(getNotifications, isClearLogin, appconfig);
  } catch (error) {
    yield (0, _effects.call)(infoAuth, 'error during init AppFrame', JSON.stringify(error));
    yield (0, _effects.put)(actions.setSnack((0, _snacks.errorSnack)(error.message)));
    yield (0, _effects.call)(_AuthStrategy.authStrategy.redirectToLogin);
  }
}
function* logout(action) {
  try {
    var _window$heap;
    const sessionAPI = yield (0, _effects.getContext)('sessionApi');
    yield (0, _effects.put)(actions.usageAnalyticsSendMessage('AppFrame', 'Action', 'Logout', window.location.pathname, 'ua'));
    if ((_window$heap = window.heap) !== null && _window$heap !== void 0 && _window$heap.loaded) {
      yield (0, _effects.call)(window.heap.track, 'Logout');
    }
    if (window.dtrum) {
      window.dtrum.endSession();
    }
    yield (0, _effects.delay)(300);
    const {
      redirectURL
    } = yield (0, _effects.call)(sessionAPI.remove, action.payload.url, action.payload.method, action.payload.options);
    yield (0, _effects.call)(_SessionStorage.default.clear);
    yield (0, _effects.call)(_AuthStrategy.authStrategy.redirectToLogin, true, redirectURL);
  } catch (error) {
    yield (0, _effects.call)(infoAuth, 'error during logout', JSON.stringify(error));
    yield (0, _effects.call)(_AuthStrategy.authStrategy.redirectToLogin);
  }
}
function _default() {
  return (0, _effects.all)([(0, _effects.takeLatest)(actions.CREATE_SESSION_PENDING, createSession), (0, _effects.takeLatest)(actions.GET_SESSION_PENDING, checkCurrentSession), (0, _effects.takeLatest)(actions.PROLONG_SESSION, checkCurrentSession), (0, _effects.takeLatest)(actions.SET_INACTIVITY_TIMER, runInactivityTimer), (0, _effects.takeLatest)(actions.SET_LIFETIME_TIMER, runLifetimeTimer), (0, _effects.takeLatest)(actions.SET_LOGOUT_TIMER, runLogoutTimer), (0, _effects.takeLatest)(actions.INIT_APPFRAME, initAppframe), (0, _effects.takeLatest)(actions.LOGOUT, logout), (0, _effects.takeLeading)([actions.INIT_APPFRAME, actions.GET_APP_CONFIG_SUCCESS, actions.GET_APP_CONFIG_ERROR, actions.HEAP_LOAD_SUCCESS, actions.HEAP_LOAD_ERROR, actions.GET_SESSION_SUCCESS, actions.DYNATRACE_LOAD_SUCCESS, actions.DYNATRACE_LOAD_ERROR], _utils.takeAllPutOne, [actions.INIT_APPFRAME, actions.GET_APP_CONFIG_RESULT, [actions.HEAP_LOAD_RESULT, actions.DYNATRACE_LOAD_RESULT], actions.GET_SESSION_SUCCESS], actions.TRACK_USER_IDENTITY), (0, _effects.takeEvery)(actions.TRACK_USER_IDENTITY, trackUser)]);
}